export class VPCEvent<T> {
    private listeners: ((args: T) => void)[] = [];

    public listenTo(listener: (args: T) => void): () => void {
        this.listeners.push(listener);

        return () => {
            this.listeners.splice(this.listeners.indexOf(listener), 1);
        };
    }

    public trigger(args: T) {
        this.listeners.forEach(listener => listener(args));
    }
}
